<div id="autocomplete_wrap" style="position: relative;">
  <input style="width: 100%; height: 30px;" id="autocomplete" input-autocomplete [config]="config2" [items]="items2"
        (inputChangedEvent)="onInputChangedEvent($event)"
        (selectEvent)="onSelect($event)" (mousedown)="onBlurMethod()">
  
</div>
